import { render, staticRenderFns } from "./projectsAside.vue?vue&type=template&id=3151f5ad&scoped=true"
import script from "./projectsAside.vue?vue&type=script&lang=js"
export * from "./projectsAside.vue?vue&type=script&lang=js"
import style0 from "./projectsAside.vue?vue&type=style&index=0&id=3151f5ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151f5ad",
  null
  
)

export default component.exports